import { PersonProfile } from '@/hooks/usePersonProfiles';
import { VisualPersonCard } from './VisualPersonCard';
import { PersonsGrid } from './PersonsGrid';

interface CategorySectionProps {
  title: string;
  icon: string;
  persons: PersonProfile[];
}

export const CategorySection = ({ 
  title, 
  icon, 
  persons
}: CategorySectionProps) => {
  // N'afficher la section que si elle contient des personnes
  if (persons.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <span className="text-2xl">{icon}</span>
        <h2 className="text-xl font-semibold text-foreground">{title}</h2>
        <span className="text-muted-foreground">({persons.length})</span>
      </div>
      
      <PersonsGrid>
        {persons.map((person) => (
          <VisualPersonCard
            key={person.id}
            person={person}
          />
        ))}
      </PersonsGrid>
    </div>
  );
};